import { addMonths } from 'date-fns'
import { setDateFromDay } from '~utils/date'

export const applyRenewDay = (day: number) => {
  const dayOfMonth = new Date().getDate()
  const dateFromDay = setDateFromDay(day)

  return dayOfMonth < day ? dateFromDay.toISOString() : addMonths(dateFromDay, 1).toISOString()
}
